<template>
  <div class="float-right">
    <v-menu offset-y left v-model="offset">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          style="min-height:35px;"
          @click.stop="handleActionClick('viewProfile'), (offset = !offset)"
        >
          <v-list-item-title>
            <img src="@/assets/line-md_account.png" alt="View Profile" />
            View Profile</v-list-item-title
          >
        </v-list-item>

        <v-list-item
          v-if="isAdminUser || isAuthor"
          style="min-height:35px;"
          @click.stop="handleActionClick('edit'), (offset = !offset)"
        >
          <v-list-item-title>
            <img src="@/assets/bx_bx-edit-alt.png" alt="Edit" />
            Edit
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="isAdminUser || isAuthor"
          style="min-height:35px;"
          @click.stop="handleActionClick('delete'), (offset = !offset)"
        >
          <v-list-item-title>
            <img src="@/assets/ic_outline-delete.png" alt="'Delete" />
            Delete
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <delete-item
      v-if="isAdminUser || isAuthor"
      :commentId="comment._id"
      module="comment"
      size="20"
      @deleteRequest="deleteRequest"
      :newsfeedId="newsfeedId"
      :comment="comment"
      :delDialog="deleteDialog"
      @closeDialog="closeDelDialog"
    ></delete-item>
    <view-profile
      :comment="comment"
      :viewProfileDialog="viewProfileDialog"
      @closeDialog="closeViewProfileDialog"
    ></view-profile>
  </div>
</template>

<script>
export default {
  name: "comment-action-menus",
  props: {
    comment: {
      type: Object
    },
    isAuthor: Boolean,
    isAdminUser: Boolean,
    newsfeedId: String
  },
  data() {
    return {
      offset: false,
      deleteDialog: false,
      viewProfileDialog: false
    };
  },
  components: {
    DeleteItem: () => import("./DeleteItem"),
    ViewProfile: () => import("./ViewProfile")
  },
  methods: {
    closeViewProfileDialog(val) {
      this.viewProfileDialog = val;
    },
    closeDelDialog(val) {
      this.deleteDialog = val;
    },
    handleActionClick(action) {
      if (action == "edit") {
        this.$parent.handleEditClick(this.comment._id);
      }
      if (action == "delete") {
        this.deleteDialog = true;
      }
      if (action == "viewProfile") {
        this.viewProfileDialog = true;
      }
    },
    deleteRequest() {
      if (typeof this.newsfeedId == "undefined") {
        this.newsfeedId = this.$route.params.id;
      }
      let parentId = this.comment.parentId
        ? this.comment.parentId
        : this.comment._id;

      this.$parent.commentResponses(parentId);
    }
  }
};
</script>
